module.exports = __webpack_public_path__ + "static/celeritas-f21f354a8a51ba55ca65f81fa348b757.svg";